export const LIST_HEADING_MAP = {
  LIST: 'List for sale',
  EDIT: 'Edit listing',
  UNLIST: 'Remove listing',
} as const;

export const LIST_CTA_MAP = {
  LIST: 'List NFT',
  UNLIST: 'Unlist NFT',
} as const;
